import React from 'react';
import { FlowModule } from './components';

const OnboardingFlow = () =>
  <div>
    <FlowModule />
  </div>;

export default OnboardingFlow;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/OnboardingFlow.js